module.exports = __webpack_public_path__ + "media/images/sp/top/area_brand_aqua@2x-06f9aa881f205603ee497ffa5cf7ab32.webp";